import type { ReportFilters } from '@/types/report';
import { countyNameFor } from './filterReport';
import { TEXAS_CITIES } from '@/geo/texasCounties';

/** Human-readable one-liner describing the active filters, shared by all three export formats so PDF/Excel/Word stay consistent with each other and with the on-screen preview. */
export function describeFilters(filters: ReportFilters): string {
  const parts: string[] = [];

  if (filters.countyGeoId) {
    parts.push(`County: ${countyNameFor(filters.countyGeoId) ?? filters.countyGeoId}`);
  } else if (filters.cityGeoId) {
    const city = TEXAS_CITIES.find((c) => c.geoId === filters.cityGeoId);
    parts.push(`City: ${city?.name ?? filters.cityGeoId} (reporting on home county)`);
  } else {
    parts.push('Region: statewide (all counties)');
  }

  if (filters.dateStart || filters.dateEnd) {
    parts.push(`Date range: ${filters.dateStart ?? 'earliest'} to ${filters.dateEnd ?? 'latest'}`);
  }

  if (filters.priceMin != null || filters.priceMax != null) {
    const fmt = (n: number) => `$${n.toLocaleString()}`;
    parts.push(
      `Price range: ${filters.priceMin != null ? fmt(filters.priceMin) : 'no min'} - ${filters.priceMax != null ? fmt(filters.priceMax) : 'no max'}`,
    );
  }

  return parts.join('  |  ');
}
